var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16A6.857 6.857 0 1 1 8 2.286 6.857 6.857 0 0 1 8 16ZM8 4a5.143 5.143 0 1 0 5.143 5.143A5.154 5.154 0 0 0 8 4ZM.297 3.794a.869.869 0 0 1-.091-1.211A10.834 10.834 0 0 1 3.314.103.846.846 0 1 1 4.103 1.6a9.143 9.143 0 0 0-2.594 2.103.869.869 0 0 1-1.212.091ZM14.492 3.703a9.143 9.143 0 0 0-2.606-2.092.846.846 0 1 1 .789-1.497 10.834 10.834 0 0 1 3.108 2.48.866.866 0 1 1-1.303 1.143l.012-.034Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.286 10H8a.869.869 0 0 1-.857-.857V6.285a.857.857 0 1 1 1.714 0V8a.286.286 0 0 0 .286.285h1.143a.857.857 0 1 1 0 1.715Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOutline);
export default __webpack_public_path__ + "static/media/clock-outline.95a2292f0cd48a7952d01ca1837a48b8.svg";
export { ForwardRef as ReactComponent };